import { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { ArrowRight, X, Bookmark } from "@phosphor-icons/react";
import { getDraft, clearDraft } from "@/lib/bookingDraft";

export default function ContinueBookingPill() {
  const location = useLocation();
  const [draft, setDraft] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  // Re-read draft whenever the route changes so it appears/disappears reactively.
  useEffect(() => {
    setDraft(getDraft());
  }, [location.pathname]);

  if (!draft || dismissed) return null;

  // Hide when the visitor is already sitting on the exact booking page that produced the draft.
  const targetPath = `/book/${draft.vertical}/${draft.lookup_key}`;
  if (location.pathname === targetPath) return null;

  const handleDiscard = (e) => {
    e.preventDefault();
    e.stopPropagation();
    clearDraft();
    setDraft(null);
    setDismissed(true);
  };

  return (
    <div
      data-testid="continue-booking-pill"
      className="fixed bottom-6 right-6 z-40 max-w-[92vw] animate-in fade-in slide-in-from-bottom-3"
    >
      <Link
        to={targetPath}
        data-sound="tock"
        className="group flex items-center gap-4 px-5 py-3 rounded-full bg-[#0F0F11]/95 backdrop-blur-md border border-[#D4AF37]/40 shadow-[0_18px_60px_-15px_rgba(212,175,55,0.35)] hover:border-[#D4AF37] transition-colors"
      >
        <div className="w-10 h-10 rounded-full bg-[#D4AF37]/10 border border-[#D4AF37]/40 flex items-center justify-center">
          <Bookmark weight="fill" size={16} className="text-[#D4AF37]" />
        </div>
        <div className="min-w-0">
          <div className="text-[10px] uppercase tracking-[0.22em] text-[#D4AF37]">Continue booking</div>
          <div className="text-white text-sm font-medium truncate max-w-[220px]">{draft.name}</div>
        </div>
        <ArrowRight size={16} weight="bold" className="text-white group-hover:text-[#D4AF37] transition-colors" />
        <button
          type="button"
          onClick={handleDiscard}
          data-testid="continue-booking-discard"
          aria-label="Discard draft"
          className="ml-1 w-7 h-7 rounded-full flex items-center justify-center text-zinc-500 hover:text-white hover:bg-white/10 transition-colors"
        >
          <X size={14} weight="bold" />
        </button>
      </Link>
    </div>
  );
}
